const ChartTop = (props)=>{
    return(
       <div className="d-flex justify-content-between text-light">
          <h5>{props.heading}</h5>
          <p>{props.heading1}</p>
       </div>
    );
}
export default ChartTop;